import type { InfractionText } from './types';

export const portInfractions: Record<string, InfractionText> = {
  HIGH_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for the {service} service. This port being open can potentially provide access to system resources and, in the worst cases, allow takeover of the host system.',
    whyRisk: 'Why is this a high risk?',
    risk: 'This open port provides a direct pathway into your network. If {service} is poorly configured or uses weak credentials, attackers could gain control of systems or access sensitive information.',
  },
  MEDIUM_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}. This potentially exposes network configuration details or infrastructure component information in the environment.',
    whyRisk: 'Why is this a medium risk?',
    risk: 'Infrastructure services on port {port} often contain configuration information and, in worse cases if not secured, can provide administrative access.',
  },
  LOW_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}. This potentially exposes network configuration details or infrastructure component information in the environment.',
    whyRisk: 'Why is this a low risk?',
    risk: 'Infrastructure services on port {port} often contain configuration information and, in worse cases if not secured, can provide administrative access.',
  },
};
